import React, { createContext, useState, useEffect, useContext } from 'react';


interface GlobalneVarijableContextType {
    grupaSifra: number;
    setGrupaSifra: (grupaSifra: number) => void;
    robaSifra: number;
    setRobaSifra: (grupaSifra: number) => void;
}

// Kreiramo kontekst s početnom vrijednošću `undefined`
const GlobalneVarijableContext = createContext<GlobalneVarijableContextType | undefined>(undefined);


export const GlobalneVarijableProvider = ({ children }:any) => {
    const [grupaSifra, setGrupaSifra] = useState<number>(0);
    const [robaSifra, setRobaSifra] = useState<number>(0);

    return (
        <GlobalneVarijableContext.Provider value={{ grupaSifra, setGrupaSifra, robaSifra, setRobaSifra }}>
            {children}
        </GlobalneVarijableContext.Provider>
    );
};

// Custom Hook za pristup dimenzijama
export const useGlobalneVarijable = () => {
    const context = useContext(GlobalneVarijableContext);
    if (!context) {
        throw new Error("useGlobalneVarijable mora biti korišten unutar GlobalneVarijableProvider-a.");
    }
    return context;
};
